package com.rainbowclubs.rainbow.domain.use_cases.membership

import com.rainbowclubs.rainbow.data.models.MembershipRequest
import com.rainbowclubs.rainbow.domain.repositories.MembershipRepository

class CreateMembershipUseCase(
    private val membershipRepository: MembershipRepository,
) {
    suspend operator fun invoke(request: MembershipRequest): Result<Boolean> {
        return membershipRepository.createMembership(request)
    }
}
